import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=aa63dbc0&scoped=true"
import script from "./bloodPressure.vue?vue&type=script&lang=js"
export * from "./bloodPressure.vue?vue&type=script&lang=js"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=aa63dbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa63dbc0",
  null
  
)

export default component.exports